import React from 'react'

const About = () => {
  return (
    <section className='bg-[#25b79f] px-0 py-24 flex flex-wrap m-auto' id='about'>
    <div className='mx-auto text-center w-[90%] mb-24'>
      <div>
        <h1 className='text-[#07374a] text-[2.5rem] font-semibold text-center'>About Me</h1>
      </div>
      <p className="text-[1.2rem] text-[#f0f0e6] text-center px-18 lg:px-24 2xl:px-32 py-0 mt-12">
        Hey there, I am M.Mehdi. I am 16 year old full stack developer and am proficient in HTML, CSS, Tailwind CSS, 
        JavaScript, Python and MERN Stack. I am expanding my circle of expertise to AI, Machine Learning, and Chatbot 
        development. I enjoy problem-solving and find satisfaction in breaking down complex ideas into simple, intuitive 
        solutions. I love to learn new things. Whether it’s exploring new technologies, tackling unfamiliar challenges, 
        or refining my existing skills, I’m always eager to improve. Alongside my formal education, I self-learn through 
        online resources, hands-on projects, and guidance from more experienced developers. Balancing my life as both a 
        student and a developer, I’m guided by curiosity, consistency, and a desire to push my limits. Every project I 
        build and every problem I solve brings me closer to my goals in this evolving field. For me, learning isn’t 
        just a phase—it’s a lifelong journey, and it’s one I truly enjoy.
      </p>
    </div>
  </section>
  )
}


export default About
